<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Медицинская справка"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeMedicalCertificate"
      />
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="medicalCertificate.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setMedicalCertificate"
      >
        <template #label>
          <span class="">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="medicalCertificate.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setMedicalCertificate"
      >
        <template #label>
          <span class="">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл документа медицинской справки"
        :ref-id="medicalCertificate?.id"
        ref-class-name="MedicalCertificate"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {MedicalCertificate} from "@/models"

export default {
  name: "MedicalCertificate",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: MedicalCertificate
  },

  data: () => ({
    medicalCertificate: new MedicalCertificate()
  }),

  computed: {},

  methods: {
    setMedicalCertificate() {
      this.$emit('set-data', this.medicalCertificate)
    },

    removeMedicalCertificate() {
      this.$emit('remove', this.medicalCertificate)
    },

    setIssueDate(value) {
      this.medicalCertificate.issueDate = value
      this.setMedicalCertificate()
    },

    setFiles(value) {
      this.medicalCertificate.filesData = value
      this.setMedicalCertificate()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.medicalCertificate = MedicalCertificate.build(this.item)
      }
    }
  }
}
</script>

<style scoped>
</style>
